import { useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export function useLegacyHistory() {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    const history = useMemo(
        () => ({
            location,
            push: (path) => navigate(path),
            replace: (path) => navigate(path, { replace: true }),
            goBack: () => navigate(-1),
        }),
        [location, navigate],
    );

    return { location, navigate, params, history };
}
